import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Link } from "react-router-dom";
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';
import Tooltip from '@material-ui/core/Tooltip';

import noimage from '../../assets/images/noimage.jpg'

import 'moment/locale/fr';
moment.locale('fr');

const styles = theme => ({
  card: {
    width: "100%",
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
    // ⚠️ object-fit is not supported by IE11.
    objectFit: 'cover',
  },
  actionArea: {
    width: '100%'
  },
  actions: {
    display: 'flex',
  },
  expand: {
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
    marginLeft: 'auto',
    [theme.breakpoints.up('sm')]: {
      marginRight: -8,
    },
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
      backgroundColor: "rgb(172, 149, 220)",
  },
  avatarIssue: {
      backgroundColor: "rgb(177, 177, 64)",
  },
  link: {
    textDecoration: 'none'
  },
  chip: {
    margin: theme.spacing.unit,
  },
});

class AuditCard extends React.Component {
  state = { expanded: false };

  handleExpandClick = () => {
    this.setState(state => ({ expanded: !state.expanded }));
  };

  render() {
    const { classes } = this.props;
    return (
      <Card className={classes.card} >
        <Link to={"/reports/" + this.props.report.id} className={classes.link}>
          <CardHeader
              avatar={
                <Tooltip title={this.props.report.audit.status === "issue" ? "Écart(s)" : "Rendez-vous validé"}>
                  <Avatar aria-label="Recipe" className={this.props.report.audit.status === "issue" ? classes.avatarIssue : classes.avatar}>
                    {this.props.report.audit.company.name.charAt(0).toUpperCase()}
                  </Avatar>
                </Tooltip>
              }
              title={this.props.report.audit.reference + " - " + this.props.report.audit.company.name.charAt(0).toUpperCase() + this.props.report.audit.company.name.slice(1)}
              subheader={this.props.report.audit.date ? moment(this.props.report.audit.date).calendar() : ""}
            />
            <CardMedia
              className={classes.media}
              image={(this.props.report.audit.preview && "path" in this.props.report.audit.preview) ? this.props.report.audit.preview.path : noimage}
              title="Lieu de l'audit"
            />
            <CardContent>
              <Typography component="p">
                Adresse : {this.props.report.audit.address}
              </Typography>
            </CardContent>
        </Link>
        <CardActions className={classes.actions} disableActionSpacing>
              <Tooltip title="Nombre de documents">
                <Chip
                  avatar={<Avatar>{this.props.report.documents.length}</Avatar>}
                  label="Doc(s)"
                  className={classes.chip}
                  color="primary"
                  variant="outlined"
                />
              </Tooltip>
              <Tooltip title="Nombre de points de contrôle">
                <Chip
                  avatar={<Avatar>{this.props.report.surveys.length}</Avatar>}
                  label="PDC(s)"
                  className={classes.chip}
                  color="primary"
                  variant="outlined"
                />
              </Tooltip>
        </CardActions>
      </Card>
    );
  }
}

AuditCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AuditCard);



// WEBPACK FOOTER //
// ./src/component/utils/ReportCard.js